import { formatReleaseDate } from './release-display'
import type { MonetaryValue } from '@shared/lib/money/money'
import { Money } from '@shared/lib/money/money'
import type { BalanceSummary } from '../api/wallet.contract'

export function balanceName(balance: Pick<BalanceSummary, 'currency'>): string {
  return `Saldo em ${balance.currency}`
}

export function isZeroAmount(amount: MonetaryValue): boolean {
  return Money.fromMonetaryValue(amount).isZero()
}

export function isPositiveAmount(amount: MonetaryValue): boolean {
  const value = Money.fromMonetaryValue(amount)
  return !value.isZero() && !value.isNegative()
}

export function isWithinAvailable(amount: MonetaryValue, available: MonetaryValue): boolean {
  const requested = Money.fromMonetaryValue(amount)
  const currentAvailable = Money.fromMonetaryValue(available)
  const difference = requested.subtract(currentAvailable)
  return difference.isZero() || difference.isNegative()
}

export function availableTotalsByCurrency(balances: BalanceSummary[]): MonetaryValue[] {
  const byCurrency = new Map<string, Money>()
  for (const balance of balances) {
    const current = byCurrency.get(balance.currency)
    const value = Money.fromMonetaryValue(balance.available)
    byCurrency.set(balance.currency, current ? current.add(value) : value)
  }
  return [...byCurrency.values()].map((total) => total.toMonetaryValue())
}

export function nextReleaseDate(balance: BalanceSummary): string | null {
  const next = nextRelease(balance)
  if (!next) return null
  return formatReleaseDate(next.date, { day: '2-digit', month: '2-digit' })
}

export function nextRelease(balance: BalanceSummary) {
  return (
    [...balance.nextReleases].sort(
      (left, right) => Date.parse(left.date) - Date.parse(right.date),
    )[0] ?? null
  )
}

export function bucketKey(balance: Pick<BalanceSummary, 'currency'>) {
  return balance.currency
}
